import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        navbar_sustain_x: "SUSTAIN-X Platform",
        esgPlatform: "ESG Platform",
        IoT_Solution_Platform: "Centralized Platform",
        navbar_product: "Products",
        navbar_services: "Services",
        navbar_about_as: "About Us",
        navbar_new_event: "News & Events",
        navbar_contact: "Contact Us",
        footer_home: "Home",
        read_more: "Read More",
        footer_location: "Location",
        footer_email: "Email",
        footer_phone: "Phone",
        footer_main_menu: "MAIN MENU",
        //หน้าหลัก
        main_esg_four_card:
          "Drive your business towards sustainability with the ESG Platform a comprehensive solution for managing environmental, social, and governance aspects. Empower your organization to measure, monitor, and report progress on sustainable development effectively.",
        main_carbon_four_card:
          "Create lasting sustainable change with the Carbon Footprint Platform and Consulting Services a tool that enables organizations to measure and analyze greenhouse gas emissions. Our expert consultants provide tailored strategies to help you achieve Net Zero goals while adding value to your business.",
        main_centralized_four_card:
          "Elevate your business with a comprehensive IoT and IT management platform. Seamlessly connect devices and critical data from all sectors in one place to enhance operational efficiency, reduce complexity, and access real-time insights.",
        main_ai_four_card:
          "Design and develop an AI Platform to meet the multidimensional needs of your business. From data analysis and operational efficiency enhancement to reducing complex manual tasks, the intelligent system learns and adapts seamlessly to your business processes for optimal effectiveness.",
        main_head_esg:
          "A platform designed to support the creation and development of businesses focused on economic, social, and environmental sustainability. It empowers businesses to operate efficiently with tools for data analysis, resource management, and best practices for sustainable operations. This promotes growth that preserves the environment and creates long-term value for all stakeholders.",
        main_sub_esg_1:
          "Dashboard visualization helps users quickly understand data and gain a clear overview.",
        main_sub_esg_2:
          "Set long-term goals and plan strategically to guide organizational direction, with tools to monitor progress effectively.",
        main_sub_esg_3:
          "Comprehensive ESG reporting enables the creation of standardized ESG performance reports for professional presentations using the ESG Platform.",
        main_head_carbon:
          "An IoT platform developed to measure and assess carbon and greenhouse gas emissions for businesses. It gathers and presents essential data for planning and implementing carbon reduction strategies. With the Carbon Footprint system, your organization can systematically manage resources and minimize environmental impact with clear and actionable goals.",
        main_sub_carbon_1:
          "Dashboards and summary reports provide a complete display of key information in an easy-to-understand format.",
        main_sub_carbon_2:
          "Real-time data monitoring supports continuous viewing and analysis through a web interface.",
        main_sub_carbon_3:
          "In-depth analysis identifies sources of carbon emissions across processes, enabling organizations to develop effective carbon reduction strategies.",
        main_sub_carbon_4:
          "Export historical reports to support audits and long-term data retention for extended analysis.",
        main_head_centralized:
          "A system that consolidates all processes and management into a single centralized platform, enabling organizations to efficiently manage data, devices, and various systems. It simplifies operations, accelerates decision-making, and can be customized and developed to meet the specific needs of businesses across diverse industries. Whether it's adding specialized features, adjusting data visualization, or integrating with existing systems, the platform is designed to adapt to your business requirements.",
        main_sub_centralized_1:
          "Connect and manage IoT devices from a centralized system for enhanced control.",
        main_sub_centralized_2:
          "Collect and analyze data from sensors across the network.",
        main_sub_centralized_3:
          "Display critical information in real-time through an intuitive dashboard.",
        main_sub_centralized_4:
          "Store and process large-scale data efficiently.",
        main_sub_centralized_5:
          "Perform in-depth data analysis for actionable insights.",
        main_sub_centralized_6:
          "Ensure data security with robust access control mechanisms.",
        main_sub_centralized_7:
          "Offer customizable features tailored to specific business requirements.",
        main_sub_centralized_8: "Provide comprehensive reporting capabilities.",
        main_head_ai:
          "Elevate performance across all dimensions by enhancing efficiency in various areas through the integration of Artificial Intelligence (AI) with other technologies such as IoT and data analytics. This approach enables Us to optimize operations in each sector effectively, meeting the ever-evolving demands of the modern world.",
        main_sub_ai_1:
          "Utilize IoT devices to count materials from images and videos, reducing the workload that relies on manual labor.",
        main_sub_ai_2:
          "Leverage AI to enhance business forecasting and strategic planning, effectively closing operational gaps and addressing issues with precision and efficiency.",
        main_sub_ai_3:
          "Develop workflows that minimize repetitive tasks while maintaining the quality and efficiency of operations.",
        main_sub_ai_4:
          "Perform in-depth data analysis to create added value and develop new business models that better meet market demands.",
        main_smart_city:
          "The city of the future, seamlessly integrating all resource data into a unified system for easier and faster management.",
        main_smart_building:
          "A comprehensive building management system that plans and allocates resources, enabling organizations to use them efficiently and strategically.",
        main_smart_factory:
          "A factory management solution providing real-time monitoring and evaluation of processes, ensuring resource usage is optimized at every stage, with detailed reporting capabilities.",
        main_head_site:
          "Explore our portfolio that reflects quality and professionalism in every project we do, and is a model of success you can trust.",
        main_head_site_talaadThai:
          "XTEN develops a Centralized management system for TalaadThai",
        main_dec_site_talaadThai:
          "An energy management and remote monitoring platform tailored for wholesale markets or other targeted areas. This system integrates data from multiple organizational systems into a single platform, covering Air Quality, Fire Alarm, RMS, and EMS.",
        main_key_site_talaadThai1: "Real-time monitoring and data recording",
        main_key_site_talaadThai2:
          "Automated alerts in case of issues or irregularities",
        main_key_site_talaadThai3: "Device management via an online platform",
        main_key_site_talaadThai4:
          "Support for data access through applications or dashboards",
        main_head_site_c24: "Charge24 All-In-One Solution Platform",
        main_dec_site_c24:
          "Charge24 is a comprehensive solution platform offering electric vehicle (EV) charging stations and software solutions. It focuses on integrating monitoring, management, billing, and user ",
        main_key_site_c241:
          "Developed Charge24 application that allows users to search for nearby charging stations, control charging processes and pay for services via mobile phones.",
        main_key_site_c242:
          "Charging station management solution for businesses and service providers who need an efficient charging station management system, including remote monitoring and data analytics.",
        main_head_site_pea:
          "XTEN developed a system for PEA to manage electric vehicle (EV) charging",
        main_dec_site_pea:
          "Equipment within buildings. The system provides the following capabilities:",
        main_key_site_pea1:
          "Optimized Power Distribution: Adjusts power supply to suit the usage of each charging station.",
        main_key_site_pea2:
          "Booking and Monitoring: Enables users to reserve charging slots and track charging status.",
        main_key_site_pea3:
          "Digital Payment Support: Facilitates service payments through digital payment methods.",
        main_key_site_pea4:
          "Energy Demand Management: Reduces congestion in energy usage during peak hours.",
        footer_location1:
          "XTEN TECHNOLOGY COMPANY LIMITED 382 Ratchadaphisek Road, Sam Sen",
        footer_location2: "Nok, Khet Huai Khwang,Bangkok, 10310 Thailand.",
        footer_location_email: "admin@xten-technology.com",
        footer_location_phone: "02-061-9988",
        news_activity_header:
          "Welcome to our All News & Activity page. Here, you'll find the latest news articles, blogs, and events curated just for you. Stay updated with all the latest happenings and important updates, and share these special moments with us today!",
        navbar_detail_all:
          "Display all news, activities, and blogs in one place for your convenience.",
        navbar_detail_news:
          "Stay updated with the latest news and stories you shouldn’t miss.",
        navbar_detail_activity:
          "Discover engaging activities and join us in creating special moments.",
        navbar_detail_blog:
          "Explore insightful articles and ideas from experts in various fields.",
        navbar_head_all: "All",
        navbar_head_news: "News",
        navbar_head_activity: "Activity",
        navbar_head_blog: "Blog",
        navbar_head_all_main: "View All News And Events",
        view_all: "View all",
        all_news_activity: "All News & Activity",
        all: "All",
        news: "News",
        activity: "Activity",
        blog: "Blog",
      },
    },
    th: {
      translation: {
        navbar_sustain_x: "SUSTAIN-X Platform",
        esgPlatform: "แพลตฟอร์ม ESG",
        IoT_Solution_Platform: "Centralized Platform",
        navbar_product: "ผลิตภัณฑ์",
        navbar_services: "บริการ",
        navbar_about_as: "เกี่ยวกับเรา",
        navbar_new_event: "ข่าวสารและกิจกรรม",
        navbar_contact: "ติดต่อเรา",
        footer_home: "หน้าหลัก",
        read_more: "เพิ่มเติม",
        footer_location: "ที่อยู่",
        footer_email: "อีเมล",
        footer_phone: "เบอร์โทรศัพท์",
        footer_main_menu: "เมนูหลัก",
        //หน้าหลัก
        main_esg_four_card:
          "ขับเคลื่อนธุรกิจสู่ความยั่งยืนด้วย ESG Platform - โซลูชันครบวงจรเพื่อการบริหารจัดการด้านสิ่งแวดล้อม สังคม และธรรมาภิบาล ช่วยองค์กรของคุณตรวจวัด ติดตาม และรายงานความคืบหน้าในการพัฒนาอย่างยั่งยืน",
        main_carbon_four_card:
          "สร้างความเปลี่ยนแปลงอย่างยั่งยืนด้วย Carbon Footprint Platform และบริการที่ปรึกษา (CF Consult) - เครื่องมือที่มีประสิทธิภาพช่วยองค์กรในการวัด วิเคราะห์ ปริมาณการปล่อยก๊าซเรือนกระจกพร้อมที่ปรึกษาที่จะช่วยกำหนดกลยุทธ์ที่เหมาะสม เพื่อก้าวสู่เป้าหมาย Net Zero และสร้างคุณค่าให้กับธุรกิจไปพร้อมกับการดูแลสิ่งแวดล้อม",
        main_centralized_four_card:
          "ยกระดับธุรกิจด้วยแพลตฟอร์มการบริหารจัดการ IoT และ IT ที่ครบวงจร เชื่อมต่ออุปกรณ์และข้อมูลสำคัญจากทุกภาคส่วนไว้ในที่เดียว เพื่อเพิ่มประสิทธิภาพการดำเนินงาน ลดความซับซ้อน และรับรู้ข้อมูลแบบเรียลไทม์",
        main_ai_four_card:
          "ออกแบบและพัฒนา AI Platform เพื่อตอบโจทย์ความต้องการในทุกมิติของธุระกิจ ทั้งการวิเคราะห์ข้อมูลการเพิ่มประสิทธิภาพการดำเนินงาน ลดภาระงานที่ซับซ้อนและต้องทำด้วยมือ (Manual) ด้วยระบบอัจฉริยะที่สามารถเรียนรู้และปรับใช้ให้เข้ากับกระบวนการทำงานของธุรกิจอย่างมีประสิทธิภาพ",
        main_head_esg:
          "แพลตฟอร์มสนับสนุนการสร้างและพัฒนาธุรกิจที่มุ่งเน้นความยั่งยืนทางเศรษฐกิจ สังคม และสิ่งแวดล้อม โดยช่วยให้ธุรกิจสามารถดำเนินการได้อย่างมีประสิทธิภาพ ด้วยเครื่องมือในการวิเคราะห์ข้อมูล, การจัดการทรัพยากร, และแนวทางปฏิบัติที่ดีที่สุดในการทำธุรกิจอย่างยั่งยืน เพื่อส่งเสริม การเติบโตที่ไม่ทำลายสิ่งแวดล้อมและสร้างคุณค่าระยะยาวให้กับทุกฝ่ายที่เกี่ยวข้อง",
        main_sub_esg_1:
          "การแสดงผลผ่านแดชบอร์ดช่วยให้ผู้ใช้งานเข้าใจข้อมูลได้อย่างรวดเร็ว และเห็นภาพรวมชัดเจน",
        main_sub_esg_2:
          "การกำหนดเป้าหมายและวางแผนระยะยาว สนับสนุนการกำหนดทิศทางองค์กร พร้อมเครื่องมือสำหรับติดตามความคืบหน้า",
        main_sub_esg_3:
          "การจัดทำรายงาน ESG ที่ครบถ้วนรองรับการจัดทำรายงานผลการดำเนินงาน ESG เพื่อการนำเสนอที่ได้มาตรฐาน ด้วย ESG Platform",
        main_head_carbon:
          "แพลตฟอร์ม IoT ที่พัฒนามาเพื่อการตรวจวัดและประเมินปริมาณการปล่อยคาร์บอนและก๊าซเรือนกระจกของธุระกิจ ช่วยรวบรวมและแสดงข้อมูลที่จำเป็นต่อการวางแผนและดำเนินกลยุทธ์ ลดการปล่อยคาร์บอนด้วยระบบ Carbon Footprint องค์กรของคุณจะสามารถบริหารจัดการทรัพยากรและลดผลกระทบต่อสิ่งแวดล้อมได้อย่างเป็นระบบและมีเป้าหมาย",
        main_sub_carbon_1:
          "แดชบอร์ดและรายงานสรุปข้อมูลแสดงผลข้อมูลสำคัญอย่างครบถ้วนในรูปแบบที่เข้าใจง่าย",
        main_sub_carbon_2:
          "ตรวจสอบข้อมูลแบบเรียลไทม์ รองรับการเรียกดูและวิเคราะห์ข้อมูลผ่านหน้าเว็บอย่างต่อเนื่อง",
        main_sub_carbon_3:
          "การวิเคราะห์เชิงลึก แสดงที่มาของการปล่อยคาร์บอนในกระบวนการต่างๆ ช่วยให้องค์กรกำหนดกลยุทธ์ลดคาร์บอนได้อย่างมีประสิทธิภาพ",
        main_sub_carbon_4:
          "ส่งออกรายงานย้อนหลัง รองรับการตรวจสอบและการเก็บบันทึกข้อมูลเพื่อการวิเคราะห์ในระยะยาว",
        main_head_centralized:
          "ระบบที่รวมกระบวนการทำงานและการจัดการทั้งหมดไว้ในศูนย์กลางเดียว ช่วยให้องค์กรสามารถบริหารจัดการข้อมูล อุปกรณ์ และระบบต่าง ๆ ได้อย่างมีประสิทธิภาพ ลดความซับซ้อน เพิ่มความรวดเร็วในการตัดสินใจ สามารถปรับแต่งและพัฒนาให้ตรงกับความต้องการเฉพาะของธุรกิจในหลากหลายอุตสาหกรรม ไม่ว่าจะเป็นการเพิ่มฟีเจอร์เฉพาะ การปรับการแสดงผลข้อมูล หรือการบูรณาการกับระบบที่มีอยู่เดิม",
        main_sub_centralized_1:
          "เชื่อมต่อและจัดการอุปกรณ์ IoT จากศูนย์กลางเพื่อการควบคุมที่ดีขึ้น",
        main_sub_centralized_2: "รวบรวมและวิเคราะห์ข้อมูลจากเซ็นเซอร์ในระบบ",
        main_sub_centralized_3: "แสดงข้อมูลสำคัญแบบเรียลไทม์ผ่านแดชบอร์ด",
        main_sub_centralized_4:
          "จัดเก็บและประมวลผลข้อมูลขนาดใหญ่ได้อย่างมีประสิทธิภาพ",
        main_sub_centralized_5: "วิเคราะห์ข้อมูลเชิงลึก",
        main_sub_centralized_6:
          "รับรองความปลอดภัยของข้อมูลด้วยกลไกการควบคุมการเข้าถึงที่แข็งแกร่ง",
        main_sub_centralized_7:
          "คุณสมบัติที่ปรับแต่งได้ให้ตรงตามข้อกำหนดทางธุรกิจที่เฉพาะเจาะจง",
        main_sub_centralized_8: "การรายงานที่ครอบคลุม",
        main_head_ai:
          "ยกระดับการทำงานในทุกมิติเพื่อเพิ่มประสิทธิภาพการทำงานในหลากหลายด้าน ด้วยการนำปัญญาประดิษฐ์ (AI) มาประยุกต์ใช้ร่วมกับเทคโนโลยีอื่น ๆ เช่น IoT และการวิเคราะห์ข้อมูล เราจึงสามารถยกระดับการทำงานในแต่ละภาคส่วนได้อย่างมีประสิทธิภาพและตอบโจทย์ความต้องการที่เปลี่ยนแปลงอยู่เสมอ",
        main_sub_ai_1:
          "ใช้อุปกรณ์ IoT ในการตรวจนับวัสดุจากภาพและวีดีโอเพื่อลดภาระงานที่ต้องใช้แรงงานคน",
        main_sub_ai_2:
          "ใช้ AI ช่วยพยากรณ์และวางแผนกลยุทธ์ธุรกิจให้มีประสิทธิภาพมากขึ้น ปิดช่องโหว่ของธุรกิจ พร้อมแก้ปัญหาได้อย่างตรงจุดและมีประสิทธิภาพ",
        main_sub_ai_3:
          "พัฒนาวิธีการทำงานเพื่อสร้าง workflow ที่ลดงานซ้ำซาก แต่ยังคงรักษาคุณภาพและประสิทธิภาพของงาน",
        main_sub_ai_4:
          "วิเคราะห์ข้อมูลเชิงลึกเพื่อสร้างมูลค่าเพิ่ม และนำไปพัฒนาโมเดลธุรกิจใหม่ที่ตอบโจทย์มากขึ้น",
        main_smart_city:
          "เมืองแห่งอนาคต เชื่อมโยงข้อมูลทรัพยากรทั้งหมดให้อยู่ในระบบเดียว เพื่อให้สามารถจัดการได้ง่ายและรวดเร็ว",
        main_smart_building:
          "ระบบการจัดการข้อมูลอาคารวางแผนและจัดสรรทรัพยากรช่วยองค์กรวางแผนการใช้ทรัพยากรอย่างมีประสิทธิภาพ",
        main_smart_factory:
          "บริหารจัดการโรงงานติดตามและประเมินผลแบบเรียลไทม์ ตรวจสอบสถานะและประสิทธิภาพการใช้ทรัพยากรในทุกขั้นตอน พร้อมรายงานผล",
        main_head_site:
          "สำรวจผลงานที่สะท้อนถึงคุณภาพและความเป็นมืออาชีพในทุกโครงการของเรา พร้อมเป็นต้นแบบความสำเร็จที่คุณวางใจได้",
        main_head_site_talaadThai:
          "XTEN พัฒนา Centralized management ให้กับ TalaadThai",
        main_dec_site_talaadThai:
          "ระบบบริหารจัดการพลังงานและการตรวจสอบแบบระยะไกล ในบริบทของตลาดค้าส่งหรือพื้นที่ที่ต้องการ เพื่อตอบโจทย์การบริหารจัดการข้อมูลจากหลากหลายระบบในองค์กรไว้ในแพลตฟอร์มเดียว (Air quality , fire alarm , RMS และ EMS)",
        main_key_site_talaadThai1: "การตรวจสอบและบันทึกข้อมูลแบบเรียลไทม์",
        main_key_site_talaadThai2: "ระบบแจ้งเตือนอัตโนมัติในกรณีเกิดปัญหา",
        main_key_site_talaadThai3: "การจัดการอุปกรณ์ผ่านแพลตฟอร์มออนไลน์",
        main_key_site_talaadThai4:
          "รองรับการดูข้อมูลผ่านแอปพลิเคชันหรือแดชบอร์ด",
        main_head_site_c24: "Charge24 แพลตฟอร์มโซลูชันแบบครบวงจร",
        main_dec_site_c24:
          "ให้บริการสถานีชาร์จรถยนต์ไฟฟ้าและโซลูชันซอฟต์แวร์ที่ครอบคลุม โดยมุ่งเน้นการผสานระบบการตรวจสอบ การจัดการ การเรียกเก็บเงิน และการมีส่วนร่วมของผู้ใช้เข้าด้วยกัน เพื่อเพิ่มประสิทธิภาพการดำเนินงานและประสบการณ์ของลูกค้า",
        main_key_site_c241:
          "พัฒนาแอปพลิเคชัน Charge24 ช่วยให้ผู้ใช้สามารถค้นหาสถานีชาร์จที่ใกล้เคียง ควบคุมกระบวนการชาร์จ และชำระค่าบริการได้ผ่านมือถือ",
        main_key_site_c242:
          "โซลูชันการจัดการสถานีชาร์จ สำหรับธุรกิจและผู้ให้บริการที่ต้องการระบบการจัดการสถานีชาร์จที่มีประสิทธิภาพ รวมถึงการตรวจสอบระยะไกลและการวิเคราะห์ข้อมูล",
        main_head_site_pea: "XTEN พัฒนาระบบ ให้กับ PEA",
        main_dec_site_pea:
          "ระบบบริหารจัดการบริภัณฑ์จ่ายไฟยานยนต์ไฟฟ้าในอาคาร ที่ให้บริการสถานีชาร์จ EV",
        main_key_site_pea1:
          "สามารถปรับการจ่ายไฟให้เหมาะสมกับการใช้งานในแต่ละสถานี",
        main_key_site_pea2: "จองเวลาและติดตามสถานะการชาร์จ",
        main_key_site_pea3: "ชำระค่าบริการรองรับการชำระเงินแบบดิจิทัล",
        main_key_site_pea4:
          "ลดปัญหาความหนาแน่นของการใช้พลังงานในช่วงเวลาเร่งด่วน",
        footer_location1: "บริษัท เอ็กซ์เทน เทคโนโลยี จำกัด",
        footer_location2:
          "382 ถนนรัชดาภิเษก แขวงสามเสนนอก เขตห้วยขวาง กรุงเทพมหานคร 10310",
        footer_location_email: "admin@xten-technology.com",
        footer_location_phone: "02-061-9988",
        news_activity_header:
          "ยินดีต้อนรับสู่หน้าแสดงข่าวสารและกิจกรรมทั้งหมดของเรา ที่นี่คุณจะได้พบกับบทความข่าว บล็อก และกิจกรรมล่าสุดที่เราคัดสรรมาเพื่อคุณ ร่วมติดตามทุกความเคลื่อนไหวและอัปเดตสำคัญ พร้อมแบ่งปันช่วงเวลาพิเศษกับเราได้แล้ววันนี้!",
        navbar_detail_all:
          "แสดงข้อมูลข่าวสารและกิจกรรมทั้งหมด รวมถึงบทความและบล็อกที่น่าสนใจในที่เดียว",
        navbar_detail_news:
          "ติดตามข่าวสารล่าสุดจากเรา อัปเดตเรื่องราวที่คุณไม่ควรพลาด",
        navbar_detail_activity:
          "ค้นพบกิจกรรมที่น่าสนใจและเข้าร่วมช่วงเวลาพิเศษไปกับเรา",
        navbar_detail_blog:
          "อ่านบทความและแนวคิดที่น่าสนใจจากผู้เชี่ยวชาญในหลากหลายสาขา",
        navbar_head_all: "ทั้งหมด",
        navbar_head_news: "ข่าวสาร",
        navbar_head_activity: "กิจกรรม",
        navbar_head_blog: "บทความ",
        navbar_head_all_main: "ดูข่าวสารและกิจกรรมทั้งหมด",
        view_all: "ทั้งหมด",
        all_news_activity: "ข่าวสารและกิจกรรม",
        all: "ทั้งหมด",
        news: "ข่าวสาร",
        activity: "กิจกรรม",
        blog: "บทความ",
      },
    },
  },
  lng: navigator.language || navigator.languages[0], // default language
  fallbackLng: "en", // fallback language
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
